import { render, staticRenderFns } from "./life-insurance-companies.html?vue&type=template&id=2ee13880&scoped=true&"
import script from "./life-insurance-companies.js?vue&type=script&lang=js&"
export * from "./life-insurance-companies.js?vue&type=script&lang=js&"
import style0 from "./life-insurance-companies.scss?vue&type=style&index=0&id=2ee13880&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee13880",
  null
  
)

export default component.exports